export default {
  add_rate: 'Adicionar taxa',
  remove_rate: 'Remover taxa',
  gateways: {
    adyen: 'Adyen',
  },
  methods: {
    fallback: 'Qualquer método de pagamento',
    card: 'Cartão',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    link: 'Link',
    paypal: 'PayPal',
    pay_by_bank: 'Pay by Bank',
    sepa_debit: 'Débito direto SEPA',
    sofort: 'Sofort',
    giropay: 'giropay',
    bacs_debit: 'Débito direto Bacs',
    stripe_other: 'Outros métodos Stripe',
  },
  fields: {
    percentage: 'Percentagem',
    fixed: 'Montante fixo',
    min: 'Montante mínimo',
  },
  // Spelled out from the row's own values, so a rate reads as the fee it
  // produces. {{method}} is the payment method, {{fixed}}/{{floor}} are
  // formatted amounts, {{percentage}} is a plain number.
  explanation: {
    none: 'Ainda não é cobrado nada em {{method}} — estes pagamentos têm uma margem de 0% até ser definida uma taxa.',
    floor_only:
      'Em {{method}}, a taxa de processamento é de {{floor}} em cada pagamento, independentemente do total do pedido.',
    percentage: 'Em {{method}}, a taxa de processamento é de {{percentage}}% do total do pedido.',
    percentage_floor:
      'Em {{method}}, a taxa de processamento é de {{percentage}}% do total do pedido, com um mínimo de {{floor}}.',
    fixed: 'Em {{method}}, a taxa de processamento é de {{fixed}} por pagamento.',
    fixed_floor: 'Em {{method}}, a taxa de processamento é de {{fixed}} por pagamento, com um mínimo de {{floor}}.',
    combined: 'Em {{method}}, a taxa de processamento é de {{fixed}} fixos mais {{percentage}}% do total do pedido.',
    combined_floor:
      'Em {{method}}, a taxa de processamento é de {{fixed}} fixos mais {{percentage}}% do total do pedido, com um mínimo de {{floor}}.',
    redundant_floor:
      'O mínimo de {{floor}} nunca se aplica — o montante fixo já o atinge em cada pagamento. Defina um valor superior a {{fixed}} ou limpe o campo.',
  },
  example: 'Exemplo: num pedido de {{total}}, a taxa de processamento é de {{fee}}.',
};
